import { makeUseAxios } from 'axios-hooks';
import { axiosInstance } from '@fides/fides-react-components';

export const useApi = makeUseAxios({
  axios: axiosInstance,
  cache: null,
});

export default useApi;
